import { Box } from '@lifeomic/chroma-react/components/Box';
import { makeStyles } from '@lifeomic/chroma-react/styles';
import React from 'react';

const useStyles = makeStyles(theme => ({
  root: {
    minHeight: theme.pxToRem(22),
    margin: theme.spacing(0, 1),
    whiteSpace: 'nowrap',
  },
}));

export const SequenceDetailsPair: React.FC = ({ children, ...rootProps }) => {
  const classes = useStyles({});
  return (
    <Box className={classes.root} align="center" {...rootProps}>
      {children}
    </Box>
  );
};
